module.exports = {
  blogPostDir: "projects", // The name of directory that contains your posts.
  siteTitle: "Flatwhite Motion Studio", // Site title.
  siteTitleAlt: "Flatwhite Motion Studio Portfolio", // Alternative site title for SEO.
  siteLogo: "/logos/logo.png", // Logo used for SEO and manifest.
  siteUrl: "https://www.flatwhitemotion.com", // Domain of your website without pathPrefix.
  pathPrefix: "/", // Prefixes all links.
  siteDescription: "A design driven motion studio based in Sydney and Qingdao.", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  googleAnalyticsID: "", // GA tracking ID.
  postDefaultCategoryID: "animation", // Default category for posts.
  userName: "Flatwhite", // Username to display in the author segment.
  profileLinks: [
    {
      name: "behance",
      url: "https://www.behance.net/alicexxyan3da2",
      iconClass: "fab fa-behance"
    },
    {
      name: "vimeo",
      url: "https://vimeo.com/flatwhitemotion",
      iconClass: "fab fa-vimeo"
    },
    {
      name: "zcool",
      url: "https://www.zcool.com.cn/u/16535424",
      iconClass: "fw-zcool"
    },
    {
      name: "xinpianchang",
      url: "http://www.xinpianchang.com/user/space/id-10370992/d-1",
      iconClass: "fw-xinpianchang"
    },
    {
      name: "wechat",
      url: "https://mp.weixin.qq.com/mp/homepage?__biz=MzUzMDE4MDkyOA==&hid=4&sn=8e25971f9a3809624a040d13684a3c1c&scene=1&devicetype=iOS11.1.2&version=16070227&lang=zh_CN&nettype=3G+&ascene=7&session_us=gh_faeb8b767a08&fontScale=100&wx_header=1",
      iconClass: "fab fa-weixin"
    },
    {
      name: "weibo",
      url: "https://weibo.com/p/1005056442908396/home?from=page_100505&mod=TAB&is_all=1",
      iconClass: "fab fa-weibo"
    }
  ],
  copyright: "Copyright © 2018. Flatwhite Motion Studio", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#f8b501", // Used for setting manifest and progress theme colors.
  backgroundColor: "#e0e0e0" // Used for setting manifest background color.
};



// WEBPACK FOOTER //
// ./data/SiteConfig.js